import { useContext } from 'react';

import { EditQBankStructureLevelItemContext } from './edit-qbank-structure-level-item-provider';

export function useEditQBSLevelItem() {
  const context = useContext(EditQBankStructureLevelItemContext);
  if (!context) {
    throw new Error(
      'useEditQBSLevelItem must be used within a EditQBankStructureLevelItemProvider',
    );
  }
  return context;
}
